import "$styles/index.css"
import "$styles/syntax-highlighting.css"

import "@awesome.me/webawesome/dist/components/button/button.js"
import "@awesome.me/webawesome/dist/components/callout/callout.js"
import "@awesome.me/webawesome/dist/components/icon/icon.js"
import "@awesome.me/webawesome/dist/components/details/details.js"
import "@awesome.me/webawesome/dist/components/dialog/dialog.js"
import "@awesome.me/webawesome/dist/components/tag/tag.js"

import JSConfetti from "js-confetti"
const jsConfetti = new JSConfetti()

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

// Recall main menu state
if (document.querySelector("nav[retain-state] wa-details")) {
  document.querySelector("nav[retain-state] wa-details").open = localStorage.getItem("main-nav-opened") === "true"
  document.querySelector("nav[retain-state] wa-details").addEventListener("wa-show", () => {
    localStorage.setItem("main-nav-opened", "true")
  })
  document.querySelector("nav[retain-state] wa-details").addEventListener("wa-hide", () => {
    localStorage.setItem("main-nav-opened", "false")
  })
}

window.bookMe = () => {
  document.querySelector("#book-dialog").open = true
}

const bodyBg = document.querySelector("body-bg")
let waitingTimer = null

function startParticleEffects() {
  if (localStorage.getItem("confetti-exploded")) {
    waitingTimer = setTimeout(() => {
      localStorage.removeItem("confetti-exploded")
      startParticleEffects();
    }, 3000)
    return
  }

  let times = 0
  let intv = 0

  intv = setInterval(() => {
    times++;
    if (times > 5) {
      clearInterval(intv)
      return
    }

    jsConfetti.addConfetti({
      confettiRadius: 4,
      confettiColors: [
        '#fcf403', '#62fc03', '#f4fc03', '#03e7fc', '#03fca5', '#a503fc', '#fc03ad', '#fc03c2'
      ],
    })
  }, 234)

  localStorage.setItem("confetti-exploded", "true")
}

window.addEventListener("scroll", () => {
  document.documentElement.style.overscrollBehavior = window.scrollY > 100 ? "none" : "auto";

  if (window.scrollY > (document.documentElement.offsetHeight - window.innerHeight)) {
    if (!document.body.classList.contains("at-the-bottom")) { startParticleEffects() }
    document.body.classList.add("at-the-bottom")
  } else {
    clearTimeout(waitingTimer)
    document.body.classList.remove("at-the-bottom")
  }

  bodyBg.style.translate = "0px " + (window.scrollY / 2) + "px";
  bodyBg.style.bottom = (window.scrollY / 2.5) + "px";
})

window.pushDaButtonMax = false
setTimeout(() => {
  if (pushDaButtonMax) return

  document.querySelector("flippy-card").classList.add("peekaboo")

  setTimeout(() => {
    document.querySelector("flippy-card").classList.remove("peekaboo")

    setTimeout(() => {
      if (pushDaButtonMax) return

      document.querySelector("flippy-card").classList.add("peekaboo")

      setTimeout(() => {
        document.querySelector("flippy-card").classList.remove("peekaboo")
      }, 200)
    }, 3000)
  }, 300)
}, 1500)
